import { apiClient } from "@/lib/api/client"
import type { Quote } from "@/lib/api/quotes"

export type { Quote }

export interface QuotesListResponse {
  success: boolean
  data: Quote[]
}

export interface QuoteDetailResponse {
  success: boolean
  data: Quote
}

export async function getQuotesApi(): Promise<QuotesListResponse> {
  const res = await apiClient.get<Quote[]>("/quotes")
  return {
    success: true,
    data: res.data,
  }
}

export async function getQuoteByIdApi(
  id: string
): Promise<QuoteDetailResponse> {
  const res = await apiClient.get<Quote>(`/quotes/${id}`)
  return {
    success: true,
    data: res.data,
  }
}

export interface CreateQuotePayload {
  plan_id: string
  input_data: Record<string, unknown>
  source?: string
  language?: "en" | "ar"
}

export async function createQuoteApi(
  payload: CreateQuotePayload
): Promise<QuoteDetailResponse> {
  const res = await apiClient.post<Quote>("/quotes", payload)
  return {
    success: true,
    data: res.data,
  }
}

export interface PricingOverridePayload {
  nova_fee_percentage?: number
  broker_fee_percentage?: number
  discount_percentage?: number
  note?: string
}

export async function updatePricingOverridesApi(
  quoteId: string,
  payload: PricingOverridePayload
): Promise<QuoteDetailResponse> {
  const res = await apiClient.patch<Quote>(
    `/quotes/${quoteId}/pricing-overrides`,
    payload
  )
  return {
    success: true,
    data: res.data ?? res,
  }
}

export async function updatePricingOverridesWithPdfApi(
  quoteId: string,
  payload: PricingOverridePayload
): Promise<QuoteDetailResponse> {
  const res = await apiClient.patch<Quote>(
    `/quotes/${quoteId}/pricing-overrides-with-pdf`,
    payload
  )
  return {
    success: true,
    data: res.data ?? res,
  }
}

export async function updateCustomerInterestApi(
  quoteId: string,
  isInterested: boolean
): Promise<QuoteDetailResponse> {
  const res = await apiClient.patch<Quote>(
    `/quotes/${quoteId}/customer-interest`,
    { isCustomerInterested: isInterested }
  )
  return {
    success: true,
    data: res.data ?? res,
  }
}
